module.exports = __webpack_public_path__ + "static/img/trans-sample-2.cb22463.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/trans-sample-2.gif
// module id = uI39
// module chunks = 1